import { Box, Button, TextField, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {  Stack} from "@mui/material";
import {
   DownloadOutlined,
   SpeakerNotesOutlined,
} from "@mui/icons-material";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { DownloadFile } from "./quotaSlice";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

export default function Comments() {
   const dispatch = useDispatch();
   const state = useSelector((store) => store.quota);

   const {
      quotaForApprovalTable, quotaCustomerBreakdown
   } = state;  
   if (quotaCustomerBreakdown === null) {
      return null;
   }
   const handleDownloadFile = (filepath) =>{
      dispatch(DownloadFile(filepath));
   }

   const {comments, listQuotaFiles} = quotaCustomerBreakdown
   return (
      quotaForApprovalTable && (
      <Box sx={{ mt: 2 }}>
         {listQuotaFiles?.length > 0 && (
                  <Stack direction="row" alignItems="center" gap={2}>
                     <AttachFileIcon  color="darkred.main" sx={{mr:-1,color: "darkred.main"}} />
                     <Typography sx={{ color: "darkred.light", fontWeight: "bold", width: "100%"}}>
                        Attachments
                     </Typography>
                  </Stack>
                )} 
               <List dense={false}>
					{listQuotaFiles?.map((file, index) => {
						return (
							<ListItem
								key={index}
							>
								<ListItemAvatar>
									<Avatar sx={{ bgcolor: "darkred.light" }}>
										<InsertDriveFileIcon
											sx={{ color: "grey.lighter" }}
										/>
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									primary={file.filePath ? file.filePath : file.name}
									secondary={false ? "Secondary text" : null}
								/>
                           <Button
                                    variant="outlined"
                                    startIcon={<DownloadOutlined />}
                                    size="small"
                                    //onClick={() => handleDownloadFile(row.filePath)}
                                    onClick={() => handleDownloadFile(file.filePath)}
                                    sx={{ 
                                       color: "darkred.light",
                                       border:"1px solid #AD2A1C",
                                       "&:hover": {
                                          bgcolor: "grey.lighter",
                                          color: "darkred.light",
                                          border:"1px solid #AD2A1C"
                                       },
                                    }}
                                 >
                                    Download
                                 </Button>{" "}
							</ListItem>
						);
					 })}
				</List>
         <div>
            <Stack direction="row" alignItems="center" gap={2} sx={{mt:3, mb: 1}}>
               
                  <Typography sx={{ color: "darkred.light", fontWeight: "bold", width: "100%" }}>
                  <SpeakerNotesOutlined sx={{transform:" translate(0px, 6px)",width: "20px", mr: 1,}} color="darkred.light" />
                     Comments
               </Typography>
            </Stack>
         </div>

         <div>
            <TextField className={'fullWidth'}
               size="large"
               multiline
               rows={6}
               style={{overflowY:'auto'}}
               value ={comments}
               disabled
               //inputProps={{ style: { width: 400 } }}
            />
         </div>
         {/* <div>
            <Button
               sx={{
                  width: 40,
                  bgcolor: "blue.main",
                  color: "white.main",
                  textTransform: "none",
                  fontWeight: "bold",
                  mt: 1,
                  "&:hover": {
                     bgcolor: "skyBlue.main",
                     color: "black.main",
                  },
               }}
            >
               View
            </Button>
         </div> */}
      </Box>
      )
   );
}
